import { $axios } from "@bloglovin/vue-framework";

export default class Base {

  apiGet(url, params = {}, successHandler, errorHandler, finallyHandler) {
    Base.apiGet(url, params, successHandler, errorHandler, finallyHandler);
  }

  apiPost(url, params = {}, successHandler, errorHandler, finallyHandler) {
    Base.apiPost(url, params, successHandler, errorHandler, finallyHandler);
  }

  apiPut(url, params = {}, successHandler, errorHandler, finallyHandler) {
    Base.apiPut(url, params, successHandler, errorHandler, finallyHandler);
  }

  static apiGet(url, params = {}, successHandler, errorHandler, finallyHandler) {
    return Base.#apiCall(
      "get",
      url,
      null,
      params,
      successHandler,
      errorHandler,
      finallyHandler,
    );
  }

  static apiPost(url, data = {}, successHandler, errorHandler, finallyHandler) {
    return Base.#apiCall(
      "post",
      url,
      data,
      {},
      successHandler,
      errorHandler,
      finallyHandler,
    );
  }

  static apiPut(url, data = {}, successHandler, errorHandler, finallyHandler) {
    return Base.#apiCall(
      "put",
      url,
      data,
      {},
      successHandler,
      errorHandler,
      finallyHandler,
    );
  }

  static #apiCall(method, url, data, params, successHandler, errorHandler, finallyHandler) {
    if (!successHandler) {
      throw new Error("app base API call must define a successHandler callback function");
    }

    const headers = {};
    if (data instanceof FormData) {
      headers["Content-Type"] = "multipart/form-data";
    }

    return $axios.request({
      method,
      url,
      data: data,
      params: params,
      headers: headers,
    }).then(response => {
      successHandler(response.data);
    }).catch(error => {
      if (errorHandler) {
        errorHandler(error);
      }
    }).finally(() => {
      if (finallyHandler) {
        finallyHandler();
      }
    });
  }
}
